import React from 'react';
import {
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  BooleanInput,
  ArrayInput,
  SimpleFormIterator,
  useTranslate,
  required,
} from 'react-admin';
import { Typography, Box } from '@mui/material';

export const FinancingEdit: React.FC = () => {
  const translate = useTranslate();

  return (
    <Edit>
      <TabbedForm>
        {/* Основная информация */}
        <FormTab label={translate('financing.tabs.basic')}>
          <TextInput
            source="subtitle"
            label={translate('financing.fields.subtitle')}
            validate={required()}
            fullWidth
          />
          <TextInput
            source="description"
            label={translate('financing.fields.description')}
            validate={required()}
            multiline
            rows={4}
            fullWidth
          />
          <BooleanInput
            source="isActive"
            label={translate('financing.fields.isActive')}
          />
        </FormTab>

        {/* Элементы финансирования */}
        <FormTab label={translate('financing.tabs.items')}>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              {translate('financing.fields.items')}
            </Typography>
            <ArrayInput source="items" label="">
              <SimpleFormIterator>
                <TextInput
                  source="title"
                  label={translate('financing.fields.itemTitle')}
                  validate={required()}
                  fullWidth
                  helperText={translate('financing.help.itemTitle')}
                />
                <TextInput
                  source="description"
                  label={translate('financing.fields.itemDescription')}
                  validate={required()}
                  multiline
                  rows={3}
                  fullWidth
                  helperText={translate('financing.help.itemDescription')}
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Box>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
